var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_4864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9383 18.125L22.4384 14.8676H19.3126V12.7537C19.3126 11.8627 19.7491 10.9937 21.1491 10.9937H22.57V8.22055C22.57 8.22055 21.2807 8.00061 20.0477 8.00061C17.4737 8.00061 15.7913 9.56099 15.7913 12.3853V14.8682H12.9299V18.1256H15.7913V26.0006H19.3126V18.1256L21.9383 18.125Z",
    fill: "#1c1c1c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.75 17C34.75 26.3888 27.1388 34 17.75 34C8.36116 34 0.75 26.3888 0.75 17C0.75 7.61116 8.36116 0 17.75 0C27.1388 0 34.75 7.61116 34.75 17ZM1.6 17C1.6 25.9194 8.8306 33.15 17.75 33.15C26.6694 33.15 33.9 25.9194 33.9 17C33.9 8.0806 26.6694 0.85 17.75 0.85C8.8306 0.85 1.6 8.0806 1.6 17Z",
    fill: "#1c1c1c"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_4864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#1c1c1c",
    transform: "translate(8.75 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBlack);
export default __webpack_public_path__ + "static/media/facebook-black.486082515a4f683319acb9f9cc74f111.svg";
export { ForwardRef as ReactComponent };